import { Icon, type IconName } from '@/components/foundations';

/** Ícone em anel dourado dos indicadores (`.ring`). O pacote só tem o tom dourado. */
export function Ring({ icon }: { icon: IconName }) {
  return <div className="ring"><Icon name={icon} /></div>;
}
